import { Box, Button, CircularProgress, Dialog, DialogContent, DialogTitle, FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import { useMutation, useQueryClient } from "react-query";
import axiosClient from "../../../../../../lib/axios";
import { enqueueSnackbar } from "notistack";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { TFormEnvioConfig } from "../DialogEditConfigFinanceiro";
import { TConfigBancariaDefault } from "../../../../../../types/api/geral/configuracoes";
import { TModalDashboard } from "..";
import { useMemo } from "react";
import { TConfiguracaoBancaria } from "../../../../../../types/api/financeiro/configuracoes-bancarias";

export default function DialogPrimeiraConfig({
    open,
    dataConfigBancarias,
    modal,
    valorConfigDefault,
    handleClose,
}: DialogPrimeiraConfigProps) {

    const queryClient = useQueryClient();
    const methods = useForm<TPrimeiraConfig>()
    const { control, watch, setValue, handleSubmit, getFieldState, formState: { errors } } = methods;

    const valorLabelModal = useMemo(() => modal === 'emissao_boleto' ? 'Boleto' : 'Pix', [modal])
    const valorModalConfigDefault = useMemo(() => modal === 'emissao_boleto' ? 'emissao_pix' : 'emissao_boleto', [modal])
    const valorInicialConfig = useMemo(() => {
        if (Object.keys(valorConfigDefault).length === 0) {
          return null;
        }
        
        return valorConfigDefault[valorModalConfigDefault] || null;
      }, [valorConfigDefault, valorModalConfigDefault]);
   

    //Querys e mutations
    const { mutate: atualizarConfig, isLoading } = useMutation({
        mutationKey: 'atualizar-config-bancaria',
        mutationFn: (inputs: any) => axiosClient.post(`atualizar-configuracoes`, inputs),
        onError: (error) => {
            console.error(error)
            enqueueSnackbar('Erro ao realizar configuração!', { variant: 'error' });
        },
        onSuccess: () => {
            queryClient.invalidateQueries(["configuracoes"])
            queryClient.invalidateQueries(["pesquisar-configuracoes-bancarias"])
            handleClose()
            enqueueSnackbar('Atulização da configuração realizada com sucesso!', { variant: 'success' });
        }
    })
    //

    //Funções manipuladoras
    const onSubmit = (data: any) => {
        const params: TFormEnvioConfig = {
            chave: 'config_bancaria_default',
            valor: {
                emissao_boleto: data.valor.emissao_boleto,
                emissao_pix: data.valor.emissao_pix
            }
        }
        atualizarConfig(params)
    }

    const handleChangeInputs = (prop: TModalDashboard, id: number) => {
        const foundIntegracao = dataConfigBancarias.find((item) => item.id === id);
        if (foundIntegracao) {
            const { integracao, ...rest } = foundIntegracao;
            setValue(`valor.${prop}`, rest)
        }
        if (valorInicialConfig){
            setValue(`valor.${valorModalConfigDefault}`, valorInicialConfig)
        }
    }
    //

    return (
        <FormProvider {...methods}>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>
                    Adicionar configuração para {valorLabelModal}
                </DialogTitle>
                {
                    dataConfigBancarias &&
                    <>
                        <Box
                            component={'form'}
                            onSubmit={handleSubmit(onSubmit)}
                        >
                            <DialogContent>
                                <Grid container spacing={2}>
                                    <Grid size={{xs: 12}}>
                                        <Controller
                                            name={`valor.${modal}.codigo`}
                                            control={control}
                                            rules={{ required: 'Campo obrigatório' }}
                                            render={({ field }) => (
                                                <FormControl fullWidth {...field} error={getFieldState(`valor.${modal}.codigo`).invalid}>
                                                    <InputLabel id="bancos-select">{valorLabelModal}*</InputLabel>
                                                    <Select
                                                        labelId="bancos-select"
                                                        value={watch(`valor.${modal}.codigo`)}
                                                        label={`${valorLabelModal}*`}
                                                        onChange={(e) => handleChangeInputs(modal, Number(e.target.value))}
                                                    >
                                                        {
                                                            dataConfigBancarias.length <= 0 &&
                                                            <MenuItem disabled>
                                                                Nenhuma integração disponível
                                                            </MenuItem>
                                                        }
                                                        {
                                                            dataConfigBancarias.length > 0 && dataConfigBancarias.map((item, index) => {
                                                                return (
                                                                    <MenuItem key={index} value={item.id}>
                                                                        {item.integracao.classe}
                                                                    </MenuItem>
                                                                );
                                                            })
                                                        }
                                                    </Select>
                                                    {getFieldState(`valor.${modal}.codigo`).error && (
                                                        <FormHelperText>{getFieldState(`valor.${modal}.codigo`).error?.message}</FormHelperText>
                                                    )}
                                                </FormControl>
                                            )}
                                        />
                                    </Grid>
                                    {/* <Grid item md={6}>
                                        <Controller
                                            name="valor.emissao_pix.codigo"
                                            control={control}
                                            rules={{ required: 'Campo obrigatório' }}
                                            render={({ field }) => (
                                                <FormControl fullWidth {...field} error={getFieldState('valor.emissao_pix.codigo').invalid}>
                                                    <InputLabel id="bancos-select">Boleto*</InputLabel>
                                                    <Select
                                                        labelId="bancos-select"
                                                        value={watch('valor.emissao_pix.codigo')}
                                                        label="Pix"
                                                        onChange={(e) => handleChangeInputs(modal, Number(e.target.value))}
                                                    >
                                                        {
                                                            dataConfigBancarias.length <= 0 &&
                                                            <MenuItem disabled>
                                                                Nenhuma integração disponível
                                                            </MenuItem>
                                                        }
                                                        {
                                                            dataConfigBancarias.length > 0 && dataConfigBancarias.map((item, index) => {
                                                                return (
                                                                    <MenuItem key={index} value={item.id}>
                                                                        {item.integracao.classe}
                                                                    </MenuItem>
                                                                );
                                                            })
                                                        }
                                                    </Select>
                                                    {getFieldState('valor.emissao_pix.codigo').error && (
                                                        <FormHelperText>{getFieldState('valor.emissao_pix.codigo').error?.message}</FormHelperText>
                                                    )}
                                                </FormControl>
                                            )}
                                        />
                                    </Grid> */}
                                </Grid>
                                <Box mt={2} width={'100%'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} gap={2}>
                                    <Button
                                        onClick={handleClose}
                                    >
                                        Cancelar
                                    </Button>
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        autoFocus
                                        disabled={isLoading}

                                    >
                                        {
                                            (isLoading) &&
                                            <CircularProgress size={20} sx={{ marginRight: 1 }} />
                                        }
                                        Adicionar
                                    </Button>
                                </Box>
                            </DialogContent>
                        </Box>
                    </>
                }
            </Dialog>
        </FormProvider>
    )
}

interface DialogPrimeiraConfigProps {
    open: boolean;
    handleClose: () => void;
    dataConfigBancarias: TConfiguracaoBancaria[]
    modal: TModalDashboard
    valorConfigDefault: TConfigBancariaDefault
}

type TPrimeiraConfig = {
    valor: TConfigBancariaDefault
}